import { render, staticRenderFns } from "./Municipalities.vue?vue&type=template&id=739f1fb6&"
import script from "./Municipalities.vue?vue&type=script&lang=js&"
export * from "./Municipalities.vue?vue&type=script&lang=js&"
import style0 from "./Municipalities.vue?vue&type=style&index=0&id=739f1fb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports